import { useBookmarks } from "features/Bookmarks";
import { SidebarNavigationItem } from "features/History/components/SidebarNavigation";
import { IBookmarkListItem } from "helpers/bookmark";
import { bookmarkListDetailPagePath } from "helpers/pageUrl";
import { useRouter } from "next/router";

const MAX_SIDEBAR_BOOKMARK_LISTS = 5;

function RecentBookmarkLists() {
  const router = useRouter();
  const handleListItemClicked = (bookmarkList: IBookmarkListItem) => {
    const link = bookmarkListDetailPagePath(bookmarkList.id);
    router.push(link);
  };

  const { bookmarkLists, isBookmarkListLoaded } = useBookmarks();

  const isLoading = !isBookmarkListLoaded || bookmarkLists.length === 0;

  if (isLoading) {
    return null;
  }

  return (
    <div className="flex pl-4">
      <div className="flex w-5 h-full py-2 justify-center -mr-0.5">
        <div className="w-px h-full bg-bg-subtle" />
      </div>
      <div className="overflow-hidden w-full">
        <ol className="overflow-hidden w-full">
          {bookmarkLists
            .slice(0, MAX_SIDEBAR_BOOKMARK_LISTS)
            .map((bookmark) => (
              <SidebarNavigationItem
                key={bookmark.id}
                id={bookmark.id}
                label={bookmark.text_label}
                url={bookmarkListDetailPagePath(bookmark.id)}
                onClick={() => handleListItemClicked(bookmark)}
              />
            ))}
        </ol>
      </div>
    </div>
  );
}

export default RecentBookmarkLists;
